import React from 'react';

const useReferralSearchParam = () => {
  const getParam = React.useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('referral');
    return param;
  }, null); // eslint-disable-line

  const [referralParam, setReferralParam] = React.useState(getParam());

  React.useEffect(() => {
    setReferralParam(getParam());
  }, [getParam]);

  return referralParam;
};

export default useReferralSearchParam;
